import apiClient from '../client';
import ENDPOINTS from '../endpoints';

/* The teacher addresses a class's emails are copied to. One row per address,
   unique per network — adding one that already exists comes back 409 with a
   message worth showing as-is. The backend lowercases the email on the way in. */

function normalizeTeacher(t) {
  return {
    id: t?._id || t?.id || '',
    name: t?.name || '',
    email: t?.email || '',
    /* 'active' | 'inactive' — only active addresses are sent to */
    status: t?.status || 'active',
  };
}

const teacherEmailsService = {
  list: async (networkId, { page = 1, limit = 50, search = '', status } = {}) => {
    const res = await apiClient.get(ENDPOINTS.ROOM_PARENT_ADMIN.TEACHER_EMAILS_BY_NETWORK(networkId), {
      params: { page, limit, search, ...(status ? { status } : {}) },
    });
    const data = res?.data ?? res;
    const rawList = data?.teacherEmails || data?.docs || data?.items || (Array.isArray(data) ? data : []);
    const total = Number(data?.totalCount ?? data?.total ?? rawList.length);
    const totalPages = Number(data?.totalPages ?? Math.max(1, Math.ceil(total / limit)));
    return { teachers: rawList.map(normalizeTeacher), total, totalPages };
  },

  add: async ({ networkId, name, email }) => {
    const res = await apiClient.post(ENDPOINTS.ROOM_PARENT_ADMIN.TEACHER_EMAIL, { networkId, name, email });
    const data = res?.data ?? res;
    return normalizeTeacher(data?.data || data);
  },

  /* Scoped to the network, so an id from another class can't be removed. */
  remove: (networkId, id) =>
    apiClient.delete(ENDPOINTS.ROOM_PARENT_ADMIN.TEACHER_EMAIL_BY_ID(networkId, id)),
};

export default teacherEmailsService;
